module fdm.clientManagement {

    angular.module('fdm.clientManagement', []);
}